import React from "react"

// Hook

function useReducedLandscapeView() {
  const [enableHiddenLabels, setEnableHiddenLabels] = React.useState<boolean>(
    Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    ) < 500 ||
      Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      ) < 500
  ) //Location state to track Device Orientation

  const [useReducedView, setUseReducedView] = React.useState<boolean>(
    Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    ) > 500
  ) //Local State to Track if Some Labels should be hidden

  React.useEffect(() => {
    if (enableHiddenLabels) {
      window.addEventListener(
        "orientationchange",
        () => {
          if (
            !(
              Math.max(
                document.documentElement.clientHeight || 0,
                window.innerHeight || 0
              ) <
              Math.max(
                document.documentElement.clientWidth || 0,
                window.innerWidth || 0
              )
            )
          )
            setUseReducedView(false)
          else setUseReducedView(true)
        },
        false
      )

      // Remove event listener on cleanup
      return () => {
        window.removeEventListener("orientationchange", () => {})
      }
    }
  }, [enableHiddenLabels, setEnableHiddenLabels])

  return useReducedView
}
export default useReducedLandscapeView
